/** */
import {
  ADD_MANY_SERVERS_TO_STORE,
  ADD_ONE_SERVER_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  LOAD_SERVERS_TO_STORE,
  REM_ONE_SERVER_FROM_STORE
} from '../actions/server';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_SERVERS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (servers, server) => ({
            ...servers,
            [server.id]: server
          }),
          {}
        )
      };
    case ADD_ONE_SERVER_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (servers, server) => ({
            ...servers,
            [server.id]: server
          }),
          {}
        )
      };
    case LOAD_SERVERS_TO_STORE:
      return {
        ...payload.reduce(
          (servers, server) => ({
            ...servers,
            [server.id]: server
          }),
          {}
        )
      };
    case REM_ONE_SERVER_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };
    default:
      return state;
  }
};
